"use client"
import { useCookies } from "next-client-cookies"
import { useEffect } from "react"

export default function SetFirstTimeURL(){
    const cookies = useCookies()
    useEffect(() => {
        const key = "firsttimeurl";
        const cookieFirstTimeURL = cookies.get(key)
        if (!cookieFirstTimeURL){
            const url = window.location.href;
            cookies.set(key, url, { expires: 365, path: "/" });
        }
    },[])
    return (<></>)
}